export default __webpack_public_path__ + "static/media/CamPacholski.72e7a161.jpg";